import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Navbar from "@/sections/Navbar";
import Hero from "@/sections/Hero";
import About from "@/sections/About";
import Services from "@/sections/Services";
import BeforeAfter from "@/sections/BeforeAfter";
import WhyUs from "@/sections/WhyUs";
import Process from "@/sections/Process";
import Industries from "@/sections/Industries";
import MarketCase from "@/sections/MarketCase";
import CTA from "@/sections/CTA";
import Contact from "@/sections/Contact";
import Footer from "@/sections/Footer";
import WhatsAppFab from "@/sections/WhatsAppFab";

function Landing() {
  return (
    <main data-testid="landing-page" className="bg-[#FAFAFA] text-stone-900">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <BeforeAfter />
      <WhyUs />
      <Process />
      <Industries />
      <MarketCase />
      <CTA />
      <Contact />
      <Footer />
      <WhatsAppFab />
    </main>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
